// Number of months to display requests for on the Request Help page
export const REQUEST_HELP_MONTHS_LOOKACK = 3;
